<div class="card">
  <div class="presentation">
    <div class="info">
      <div class="header">
        <h1 class="title">API Commerce</h1>
        <p class="subtitle">Cobrá en criptomonedas</p>
      </div>
      <div class="items">
        <p class="item">Acreditación instantánea</p>
        <p class="item">Sin riesgo</p>
        <p class="item">Global</p>
        <p class="item">Solo 1% de fee</p>
      </div>
      <div class="actions">
        <button (click)="enableCommerce()" [disabled]="commerceOnboarded" class="td-btn primary">
          Sumate
        </button>
        <a class="more-info" target="_blank" href="https://tiendacrypto.com/commerce">Ver más</a>
      </div>
    </div>
    <div class="image"></div>
  </div>
</div>
